module.exports = __webpack_public_path__ + "static/img/function03.0cab492a.png";